import { Navigate } from "react-router";
import { LoadingContent } from "../Shared/LoadingContent";

export type FeaturedRouteProps = {
    featureCheckLogic: () => boolean
    isLoading: () => boolean
}

/// Makes sure that the feature is on, if the feature is off the user is redirected to the landing page
export const FeaturedRoute = (props: React.PropsWithChildren<FeaturedRouteProps>) => {
    
    if (!props.isLoading() && !props.featureCheckLogic()) {
        return <Navigate to="/" />;
    }

    return (<>
        <LoadingContent loading={props.isLoading()} classes="w-100 text-center">
            {props.children}
        </LoadingContent>
    </>);
}